import React, {useEffect, useRef} from 'react';
import '../style/carouselStyle.css';

function Carousel() {
    const currdeg = useRef(0)
    const autoTurn = useRef(null);
    useEffect(() => {
        autoTurn.current = setInterval(() => rotate_p(), 3000);

        return (() => clearInterval(autoTurn.current))
    }, [])
    function stopAutoTurn() {
        clearInterval(autoTurn.current)
    }
    function rotate_n () {
        currdeg.current = currdeg.current - 60;
        document.querySelector(".carousel").style = 
        '-webkit-transform: rotateY(' + currdeg.current + 'deg);' +
        '-moz-transform: rotateY(' + currdeg.current + 'deg);' +
        '-o-transform: rotateY(' + currdeg.current + 'deg);' +
        'transform: rotateY(' + currdeg.current + 'deg);'
    }
    function rotate_p () {
        currdeg.current = currdeg.current + 60;
        document.querySelector(".carousel").style = 
        '-webkit-transform: rotateY(' + currdeg.current + 'deg);' +
        '-moz-transform: rotateY(' + currdeg.current + 'deg);' +
        '-o-transform: rotateY(' + currdeg.current + 'deg);' +
        'transform: rotateY(' + currdeg.current + 'deg);'
    }
    return (
        <>
            <div className="carousel_container noselect">
                <div className="carousel">
                    <div className="item a">
                        <img className="carImage" src={process.env.PUBLIC_URL + '/carouselImage/carImg1.jpg'} alt="to right" />
                    </div>
                    <div className="item b">
                        <img className="carImage" src={process.env.PUBLIC_URL + '/carouselImage/carImg2.jpg'} alt="to right" />
                    </div>
                    <div className="item c">
                        <img className="carImage" src={process.env.PUBLIC_URL + '/carouselImage/carImg3.jpg'} alt="to right" />
                    </div>
                    <div className="item d">
                        <img className="carImage" src={process.env.PUBLIC_URL + '/carouselImage/carImg4.jpg'} alt="to right" />
                    </div>
                    <div className="item e">
                        <img className="carImage" src={process.env.PUBLIC_URL + '/carouselImage/carImg5.jpg'} alt="to right" />
                    </div>
                    <div className="item f">
                        <img className="carImage" src={process.env.PUBLIC_URL + '/carouselImage/carImg6.jpg'} alt="to right" />
                    </div>
                </div>
            </div>
            <div className="noselect carousel_arrow" id="next" onClick={() => {stopAutoTurn();rotate_p();}}>
                <img src={process.env.PUBLIC_URL + '/icons/arrow_type_1.png'} alt="to right" />
            </div>
            <div className="noselect carousel_arrow" id="prev" onClick={() => {stopAutoTurn();rotate_n();}}>
                <img
                    src={process.env.PUBLIC_URL + '/icons/arrow_type_1.png'}
                    style={{transform: 'rotateY(180deg)'}}
                    alt="to left" />
            </div>
        </>
    );
}

export default Carousel;